// extracted by mini-css-extract-plugin
export default {"title":"hotelCardTitle-module__title__QniWi","titleMobile":"hotelCardTitle-module__titleMobile__fB5zI","titleMapCard":"hotelCardTitle-module__titleMapCard__CcpJX"};